import { Box, Theme } from '@mui/material';
import { ReactElement } from 'react';

/**
 * The "Selected" pill on a chosen card or row. It sits centred on the bottom edge of the nearest
 * positioned ancestor. Decorative: the chosen state is carried by `aria-checked` on the control.
 */
export function SelectedPill({ label }: Readonly<{ label: string }>): ReactElement {
  return (
    <Box
      component="span"
      aria-hidden="true"
      sx={(theme: Theme) => ({
        position: 'absolute',
        left: '50%',
        bottom: 0,
        transform: 'translate(-50%, 50%)',
        paddingBlock: theme.semantic.spacing['4xs'],
        paddingInline: theme.semantic.spacing.xs,
        borderRadius: theme.semantic.borderRadius.round,
        backgroundColor: theme.palette.permanent.primary,
        color: theme.palette.text.permanentWhite,
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.semantic.fontSize.xs,
        lineHeight: theme.semantic.lineHeight.standard,
        whiteSpace: 'nowrap',
      })}
    >
      {label}
    </Box>
  );
}
